import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInactivate = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		r: 50,
		fill: "#EA1A0F"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M71.0472 76.7041C65.2581 81.2732 57.9475 84 50 84C31.2223 84 16 68.7777 16 50C16 42.0525 18.7268 34.7419 23.2959 28.9528L71.0472 76.7041ZM76.7041 71.0472L28.9528 23.2959C34.7419 18.7268 42.0525 16 50 16C68.7777 16 84 31.2223 84 50C84 57.9475 81.2732 65.2581 76.7041 71.0472ZM92 50C92 73.196 73.196 92 50 92C26.804 92 8 73.196 8 50C8 26.804 26.804 8 50 8C73.196 8 92 26.804 92 50Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgInactivate);
export default ForwardRef;
